// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wGKBH8gMFgQ_20t9TwHI{justify-content:space-between;align-items:center;display:flex}.k1Au2E4NrgArQoPosVWd{flex:0 0 125px;min-height:32px}.ZQqNS1bhgY44n4OPCIUj,.QsyEhzH8kiD9xuIUatsU{width:100%}.cGUJfdrYgwwPrfGPwIyN{color:var(--content-primary-primary)}.cGUJfdrYgwwPrfGPwIyN span{color:var(--content-primary-tertiary)}.Xir7dNVXRCgx6olRxA1Z{align-items:center;gap:8px;display:flex}.wvF2arRDfLwAsEyuKM8b{padding:0 4px}.AcoXawQ4LaEQ2HhCEZm6,.AcoXawQ4LaEQ2HhCEZm6>div{width:100%}.kU1wQB1KtUwtWhi4H9oq .MuiTooltip-arrow{left:10px!important;transform:none!important}.vArFiVnJ2rQzoSYsF15v{flex-direction:column;display:flex}.vArFiVnJ2rQzoSYsF15v .TuyN1Vuiizc133GV8NEJ.roz2uL8v9k87FRWnxZKL{margin-top:10px}.vArFiVnJ2rQzoSYsF15v .MCGSoPixEqkqGFJ4gcep{margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `wGKBH8gMFgQ_20t9TwHI`,
	"label": `k1Au2E4NrgArQoPosVWd`,
	"trigger": `ZQqNS1bhgY44n4OPCIUj`,
	"input": `QsyEhzH8kiD9xuIUatsU`,
	"text": `cGUJfdrYgwwPrfGPwIyN`,
	"wrapPlaceholder": `Xir7dNVXRCgx6olRxA1Z`,
	"loaderTrigger": `wvF2arRDfLwAsEyuKM8b`,
	"tooltip": `AcoXawQ4LaEQ2HhCEZm6`,
	"tooltip-content": `kU1wQB1KtUwtWhi4H9oq`,
	"tooltipContent": `kU1wQB1KtUwtWhi4H9oq`,
	"tooltipContentList": `vArFiVnJ2rQzoSYsF15v`,
	"tooltipContentDesc": `TuyN1Vuiizc133GV8NEJ`,
	"last": `roz2uL8v9k87FRWnxZKL`,
	"tooltipContentCount": `MCGSoPixEqkqGFJ4gcep`
};
export default ___CSS_LOADER_EXPORT___;
